// ONLY IMPORT THIS FILE IN REDUCER SLICES
import { createAction } from '@reduxjs/toolkit';

import type { RemoveItemsPayload } from '@app/store/items/types';

export const removeItems =
  createAction<RemoveItemsPayload>('items/removeItems');
